import { connect } from 'react-redux';
import AppInner from './AppInner';
import { addItemProduct } from '../actions/designActions';
import { getDesignByItem } from '../actions/actionCreators';
import { getSplitUrlQuery } from '../utils/pathUtils';

const urlInitial = typeof window !== 'undefined' ? decodeURIComponent(document.baseURI) : '';
const splitUrl = getSplitUrlQuery(urlInitial);

const mapStateToProps = (state) => {
  const {
    config: { partnerProductId },
    configurator: { ajaxStatus: { isLoading, isInitialized } },
  } = state;

  return { partnerProductId, isInitialized, isLoading };
};

const mapDispatchToProps = (dispatch) => ({
  appMount: (productId, itemId, isFromSave) => {
    const isNotRedirectParam = !splitUrl.includes('signin?redirect=');
    if (isNotRedirectParam && itemId) {
      dispatch(getDesignByItem({ itemId, isFromSave }));
    }
  },
  onConfiguratorLoaded: (isFromSave, currentDesignId, itemId, configurationId) => {
    if (isFromSave) {
      dispatch(addItemProduct(currentDesignId, itemId, configurationId));
    }
  },
  onSaveConfiguration: (currentDesignId, itemId, data) => {
    dispatch(addItemProduct(currentDesignId, itemId, data?.configurationGuid));
  },
  // called after EXECUTE_RULES_SUCCESS
  afterRulesExecuted: () => Promise.resolve()
});

export default connect(mapStateToProps, mapDispatchToProps)(AppInner);
